module.exports = require("@graphistry/falcor-path-utils/lib/flatBufferToPaths");


//////////////////
// WEBPACK FOOTER
// external "@graphistry/falcor-path-utils/lib/flatBufferToPaths"
// module id = 99
// module chunks = 0